import {
  AllForemanId,
  AllGeneralForemanId,
  AllSuperintendentId,
  EllipsisPlacement,
  PersonaMessages,
  TextWithEllipsis,
  UnassignedForemanId,
  UnassignedGeneralForemanId,
  UnassignedSuperintendentId,
  useName,
  usePlanning,
} from '@bechtel/client-common';
import { Box, Text } from '@bechtel/gds';
import { CrewMember } from '@bechtel/types';
import { useLingui } from '@lingui/react';
import { FC } from 'react';
import { AvatarRegularStyled, ForemanCollapsedStyled, OwnerNameStyled } from './styled';
interface CrewMemberItemProps {
  crewMember: CrewMember;
}
const CrewMemberItem: FC<CrewMemberItemProps> = ({ crewMember }) => {
  const { getFullName } = useName();
  const { i18n } = useLingui();
  const isCrewUnAssigned = crewMember?.id == AllForemanId ||
  crewMember?.id == AllGeneralForemanId ||
  crewMember?.id == AllSuperintendentId ||
  crewMember?.id === UnassignedSuperintendentId ||
  crewMember?.id === UnassignedGeneralForemanId ||
  crewMember?.id === UnassignedForemanId
  
  return (
    <Box flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-between' }}>
      <AvatarRegularStyled
        hasImageUrl={crewMember.imageUrl ? true : false}
        src={crewMember.imageUrl ? crewMember.imageUrl : undefined}
      />
      <OwnerNameStyled>
        <TextWithEllipsis size="300" color="grey.1000" weight="600" ellipsisPlacement={EllipsisPlacement.END}>
          {isCrewUnAssigned
            ? i18n._(crewMember.firstName)
            : getFullName(crewMember.firstName, crewMember.lastName)}
        </TextWithEllipsis>
      </OwnerNameStyled>
      {isCrewUnAssigned && (
        <Text size="200" color="grey.1000" transform="capitalize">
          {i18n._(PersonaMessages[crewMember.persona])}
        </Text>
      )}
    </Box>
  );
};
interface ForemanCollapsedProps {
  hidden: boolean;
}
export const ForemanCollapsed: FC<ForemanCollapsedProps> = ({ hidden }) => {
  const { selectedForeman, selectedGeneralForeman, selectedSuperintendent } = usePlanning();
  return (
    <ForemanCollapsedStyled hidden={hidden}>
      <CrewMemberItem crewMember={selectedSuperintendent} />
      <CrewMemberItem crewMember={selectedGeneralForeman} />
      <CrewMemberItem crewMember={selectedForeman} />
    </ForemanCollapsedStyled>
  );
};
